<template>
  <div>
    <div id="listTop">
      <ul class="listLeft">
        <li
          v-for="(item, index) in slist"
          :key="index"
          @click="clickLi(index)"
          :class="{ active: now == index }"
        >
          <span class="label">{{ item.name }}</span>
          <span>
            {{ item.arr.length }}
          </span>
        </li>
      </ul>
      <div class="listRight">
        <a @click="changeStatus" style="margin-right: 10px">{{
          btntext[status]
        }}</a>
        <a @click="min">收起</a>
      </div>
    </div>
    <lyTable
      :columns="columns"
      :data="tableData"
      :height="height"
      style="margin-bottom: 0"
      @tr="clickTr"
    >
      <template slot-scope="{ row, index }" slot="realTimeStatus">
        <car-statue :realTimeStatus="row.realTimeStatus" :statusDuration="row.statusDuration"></car-statue>
      </template>
    </lyTable>
  </div>
</template>
<script>
var all = [],
  parking = [],
  stay = [],
  driving = [],
  offline = [],
  alarm = [];
import carStatue from "../common/carStatue.vue";
export default {
  components: { carStatue },
  data() {
    return {
      columns: [
        {
          type: "index",
          width: 70,
        },
        {
          title: "名称",
          key: "name",
          width: 100,
        },
        {
          title: "设备号",
          key: "deviceNo",
          width: 100,
        },
        {
          title: "状态",
          slot: "realTimeStatus",
          width: 80,
        },
        {
          title: "北斗时间",
          key: "gpsTime",
          width: 130,
        },
        {
          title: "报警类型",
          key: "alarmList",
          width: 130,
        },
        {
          title: "事件说明",
          key: "eventDesc",
          width: 130,
        },
        {
          title: "速度",
          key: "speed",
          width: 100,
        },
        {
          title: "里程",
          key: "mileage",
          width: 100,
        },
        {
          title: "发动机",
          key: "accStatus",
          width: 100,
        },
        {
          title: "信号",
          key: "flag",
          width: 100,
        },
        {
          title: "单位名称",
          key: "groupName",
          width: 130,
        },
      ],
      tableData: [],
      status: 1,
      btntext: {
        1: "全屏", //常规
        2: "常规", //最大
      },
      slist: {
        0: { name: "选中数量", arr: all },
        1: { name: "离线数量", arr: offline },
        2: { name: "停车数量", arr: parking },
        3: { name: "行驶储量", arr: driving },
        4: { name: "停留数量", arr: stay },
        5: { name: "报警数量", arr: alarm },
      },
      now: 0,
      height: 150,
    };
  },
  methods: {
    websockToLocate(data, m) {
      var fs = 1000;
      all.splice(0, fs);
      parking.splice(0, fs);
      stay.splice(0, fs);
      driving.splice(0, fs);
      offline.splice(0, fs);
      alarm.splice(0, fs);

      for (let i = 0; i < data.length; i++) {
        all.push(data[i]);

        var s = data[i].realTimeStatus;
        if (s == 1) {
          offline.push(data[i]);
        } else if (s == 2) {
          parking.push(data[i]);
        } else if (s == 3) {
          driving.push(data[i]);
        } else if (s == 4) {
          stay.push(data[i]);
        }
        if (data[i].alarmStatus == 1) {
          alarm.push(data[i]);
        }
      }
      //this.tableData = all;
      this.clickLi(this.now);
    },
    changeStatus() {
      var h=document.body.clientHeight;
      
      //0 1 2
      if (this.status == 2) {
        this.status = 1;
        this.height = 150;
      } else if (this.status == 1) {
        this.status = 2;
        this.height = h-80;
      }
      this.$emit("status", this.status);
    },
    min() {
      //this.status = 0;
      this.height = 0;
      this.$emit("status", 0);
    },
    clickLi(index) {
      this.now = index;
      this.tableData = this.slist[index].arr;
    },
    clickTr(v) {
      this.$emit("tr", v);
    },
  },
};
</script>
<style>
#listTop {
  display: flex;
  line-height: 24px;
}
#listTop .listLeft {
  width: calc(100% - 40px);
  display: flex;
}
#listTop .listLeft li {
  cursor: pointer;
  padding: 4px 8px;
}
#listTop .listLeft li .label {
  margin-right: 4px;
}
#listTop .listLeft li.active {
  background: #2480d6;
  color: #fff;
}
#listTop .listRight {
  width: 80px;
  margin-left: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/locate/locateList.vue